<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>ນັກຮຽນ</h4>
            <h6>ຈັດການລະຫັດຜ່ານຂອງນັກຮຽນ</h6>
          </div>
        </div>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            @click="showAddModal"
          ><vue-feather type="plus-circle" class="me-2"></vue-feather>ເພີ່ມນັກຮຽນ</a>    
        </div>
        <div class="page-btn">
          <input
            type="file"
            ref="fileInput"
            accept=".csv"
            style="display: none"
            @change="handleFileUpload"
          />
          <a
            href="javascript:void(0);"
            class="btn btn-added ms-2"
            @click="$refs.fileInput.click()"
          ><vue-feather type="upload" class="me-2"></vue-feather>ນຳເຂົ້າ CSV</a>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input ms-2">
                <select v-model="selectedYear" class="form-control">
                  <option value="">ທຸກປີ</option>
                  <option v-for="year in availableYears" :key="year" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
              <div class="search-input ms-2">
                <select v-model="selectedClass" class="form-control">
                  <option value="">ທຸກຫ້ອງ</option>
                  <option v-for="class_ in filteredClasses" :key="class_.id" :value="class_.id">
                    {{ class_.name }}
                  </option>
                </select>
              </div>
          
              <div class="search-input">
                <input
                  type="text"
                  v-model="searchQuery"
                  placeholder="ຄົ້ນຫານັກຮຽນ..."
                  class="form-control"
                />
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <a-table
              class="table datanew table-hover table-center mb-0"
              :columns="columns"
              :data-source="filteredPasswords"
              :pagination="{
                pageSize: itemsPerPage,
                total: filteredPasswords.length,
                showSizeChanger: false
              }"
              :loading="loading"
            >
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="confirm-text p-2"
                        @click="showConfirmation(record)"
                        href="javascript:void(0);"
                      >
                        <i data-feather="trash-2" class="feather-trash-2"></i>
                      </a>
                    </div>
                  </td>
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Modal -->
    <div class="modal fade" id="passwordModal" ref="passwordModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ isEditing ? 'ແກ້ໄຂ' : 'ເພີ່ມ' }} ນັກຮຽນ</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="savePassword">
              <div class="form-group">
                <label>ຊື່</label>
                <input
                  type="text"
                  v-model="formData.firstname"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>ນາມສະກຸນ</label>
                <input
                  type="text"
                  v-model="formData.lastname"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>ລະຫັດຜ່ານ</label>
                <input
                  type="text"
                  v-model="formData.Password"
                  class="form-control"
                  required
                />
              </div>
              <div class="form-group">
                <label>ເພດ</label>
                <select v-model="formData.gender" class="form-control" required>
                  <option value="">ເລືອກເພດ</option>
                  <option value="male">ຊາຍ</option>
                  <option value="female">ຍິງ</option>
                  <option value="other">ອື່ນໆ</option>
                </select>
              </div>
              <div class="form-group">
                <label>ຫ້ອງ</label>
                <select v-model="formData.classId" class="form-control">
                  <option value="">ເລືອກຫ້ອງ</option>
                  <option v-for="class_ in filteredClasses" :key="class_.id" :value="class_.id">
                    {{ class_.name }}
                  </option>
                </select>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ຍົກເລີກ</button>
                <button type="submit" class="btn btn-primary">{{ isEditing ? 'ອັບເດດ' : 'ບັນທຶກ' }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import passwordService from '@/services/password.service';
import classService from '@/services/class.service';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';

export default {
  setup() {
    const passwords = ref([]);
    const classes = ref([]);
    const searchQuery = ref('');
    const isEditing = ref(false);
    const formData = ref({
      firstname: '',
      lastname: '',
      Password: '',
      gender: '',
      classId: ''
    });

    const passwordModal = ref(null);
    const modalInstance = ref(null);
    const selectedClass = ref('');
    const selectedYear = ref('');

    const availableYears = computed(() => {
      const years = new Set();
      classes.value.forEach(cls => {
        if (cls.year) years.add(cls.year);
      });
      return Array.from(years).sort();
    });

    const filteredClasses = computed(() => {
      if (!selectedYear.value) {
        return classes.value;
      }
      return classes.value.filter(cls => cls.year === selectedYear.value);
    });

    const filteredPasswords = computed(() => {
      return passwords.value.filter(password => {
        const matchesSearch = !searchQuery.value || 
          (password.firstname?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          password.lastname?.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
          password.Password?.toLowerCase().includes(searchQuery.value.toLowerCase()));
        
        const matchesClass = !selectedClass.value || password.classId === parseInt(selectedClass.value);
        
        const classObj = classes.value.find(c => c.id === password.classId);
        const matchesYear = !selectedYear.value || (classObj && classObj.year === selectedYear.value);
        
        return matchesSearch && matchesClass && matchesYear;
      });
    });

    const loadPasswords = async () => {
      try {
        const response = await passwordService.getAllPasswords();
        passwords.value = response.data;
      } catch (error) {
        console.error('Error loading passwords:', error);
        Swal.fire('Error', 'Failed to load students', 'error');
      }
    };

    const loadClasses = async () => {
      try {
        const response = await classService.getAllClasses();
        classes.value = response.data;
      } catch (error) {
        console.error('Error loading classes:', error);
      }
    };

    const showAddModal = () => {
      isEditing.value = false;
      formData.value = {
        firstname: '',
        lastname: '',
        Password: '',
        classId: ''
      };
      // Template ref automatically binds to passwordModal
      const modalElement = document.getElementById('passwordModal');
      if (modalElement) {
        if (modalInstance.value) {
          modalInstance.value.hide();
          modalInstance.value.dispose();
        }
        try {
          modalInstance.value = new Modal(modalElement, {
            backdrop: 'static',
            keyboard: false
          });
          modalInstance.value.show();
        } catch (error) {
          console.error('Modal initialization error:', error);
          Swal.fire('Error', 'Failed to initialize modal', 'error');
        }
      } else {
        Swal.fire('Error', 'Modal element not found', 'error');
      }
    };

    const editPassword = (password) => {
      isEditing.value = true;
      formData.value = { ...password };
      // Template ref automatically binds to passwordModal
      const modalElement = document.getElementById('passwordModal');
      if (modalElement) {
        if (modalInstance.value) {
          modalInstance.value.hide();
          modalInstance.value.dispose();
        }
        try {
          modalInstance.value = new Modal(modalElement, {
            backdrop: 'static',
            keyboard: false
          });
          modalInstance.value.show();
        } catch (error) {
          console.error('Modal initialization error:', error);
          Swal.fire('Error', 'Failed to initialize modal', 'error');
        }
      } else {
        Swal.fire('Error', 'Modal element not found', 'error');
      }
    };

    const savePassword = async () => {
      try {
        if (isEditing.value) {
          await passwordService.updatePassword(formData.value.id, formData.value);
          Swal.fire('ສຳເລັດ', 'ອັບເດດນັກຮຽນສຳເລັດແລ້ວ', 'success');
        } else {
          await passwordService.createPassword(formData.value);
          Swal.fire('ສຳເລັດ', 'ເພີ່ມນັກຮຽນສຳເລັດແລ້ວ', 'success');
        }
        modalInstance.value.hide();
        loadPasswords();
      } catch (error) {
        console.error('Error saving password:', error);
        Swal.fire('ຜິດພາດ', 'ບໍ່ສາມາດບັນທຶກນັກຮຽນໄດ້', 'error');
      }
    };

    const confirmDelete = (password) => {
      Swal.fire({
        title: 'ທ່ານແນ່ໃຈບໍ?',
        text: 'ທ່ານຈະບໍ່ສາມາດກູ້ຄືນໄດ້!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ແມ່ນ, ລຶບອອກ!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await passwordService.deletePassword(password.id);
            loadPasswords();
            Swal.fire('ລຶບແລ້ວ!', 'ນັກຮຽນຖືກລຶບແລ້ວ.', 'success');
          } catch (error) {
            console.error('Error deleting password:', error);
            Swal.fire('ຜິດພາດ', 'ບໍ່ສາມາດລຶບນັກຮຽນໄດ້', 'error');
          }
        }
      });
    };

    onMounted(() => {
      loadPasswords();
      loadClasses();
    });

    const itemsPerPage = 10;
    const currentPage = ref(1);

    const paginatedPasswords = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage;
      const end = start + itemsPerPage;
      return filteredPasswords.value.slice(start, end);
    });

    const totalPages = computed(() => {
      return Math.ceil(filteredPasswords.value.length / itemsPerPage);
    });

    const changePage = (page) => {
      currentPage.value = page;
    };

    const loading = ref(false);
    
    const columns = [
      {
        title: 'ຊື່',
        dataIndex: 'firstname',
        key: 'firstname'
      },
      {
        title: 'ນາມສະກຸນ',
        dataIndex: 'lastname',
        key: 'lastname'
      },
      {
        title: 'ລະຫັດຜ່ານ',
        dataIndex: 'Password',
        key: 'Password'
      },
      {
        title: 'ເພດ',
        dataIndex: 'gender',
        key: 'gender'
      },
      {
        title: 'ຫ້ອງ',
        dataIndex: 'class',
        key: 'class',
        customRender: ({ record }) => {
          const classObj = classes.value.find(c => c.id === record.classId);
          return classObj ? classObj.name : '';
        }
      },
      {
        title: 'ປີ',
        key: 'year',
        customRender: ({ record }) => {
          const classObj = classes.value.find(c => c.id === record.classId);
          return classObj && classObj.year ? classObj.year : '';
        }
      },
      {
        title: 'ຈັດການ',
        key: 'action'
      }
    ];

    const openEditModal = (record) => {
      editPassword(record);
    };

    const showConfirmation = (record) => {
      confirmDelete(record);
    };

    const handleFileUpload = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvData = e.target.result;
          const rows = csvData.split('\n').map(row => row.split(','));
          const headers = rows[0].map(header => header.trim().toLowerCase());

          // Validate headers
          const requiredFields = ['firstname', 'lastname', 'password', 'class', 'gender'];
          const missingFields = requiredFields.filter(field => !headers.includes(field));

          // Gender mapping for Lao language
          const genderMapping = {
            'ທ້າວ': 'male',
            'ນາງ': 'female'
          };

          if (missingFields.length > 0) {
            Swal.fire('ຜິດພາດ', `ຂາດຂໍ້ມູນທີ່ຈຳເປັນ: ${missingFields.join(', ')}`, 'error');
            return;
          }

          loading.value = true;
          let successCount = 0;
          let errorCount = 0;

          // Process each row (skip header)
          for (let i = 1; i < rows.length; i++) {
            if (rows[i].length === headers.length) {
              const studentData = {};
              headers.forEach((header, index) => {
                studentData[header] = rows[i][index].trim();
              });

              try {
                const className = studentData.class.trim();
                let classObj = classes.value.find(c => c.name.toLowerCase() === className.toLowerCase());
                
                // If class doesn't exist and year is provided in CSV, create the class with year
                if (!classObj && studentData.year) {
                  try {
                    const response = await classService.createClass({
                      name: className,
                      year: studentData.year
                    });
                    classObj = response.data;
                    // Add the new class to the classes array
                    classes.value.push(classObj);
                  } catch (error) {
                    console.error(`Error creating class ${className}:`, error);
                    throw new Error(`Class "${className}" could not be created`);
                  }
                } else if (!classObj) {
                  throw new Error(`Class "${className}" not found`);
                }

                await passwordService.upsertPassword({
                  firstname: studentData.firstname,
                  lastname: studentData.lastname,
                  Password: studentData.password,
                  classId: classObj.id,
                  gender: genderMapping[studentData.gender] || 'other'
                });
                successCount++;
              } catch (error) {
                console.error(`Error creating student at row ${i + 1}:`, error);
                errorCount++;
              }
            }
          }

          loading.value = false;
          await loadPasswords();

          Swal.fire(
            'ນຳເຂົ້າສຳເລັດ',
            `ນຳເຂົ້ານັກຮຽນສຳເລັດ ${successCount} ຄົນ.${errorCount > 0 ? ` ນຳເຂົ້າບໍ່ສຳເລັດ ${errorCount} ຄົນ.` : ''}`,
            successCount > 0 ? 'success' : 'warning'
          );
        } catch (error) {
          console.error('Error processing CSV:', error);
          Swal.fire('ຜິດພາດ', 'ບໍ່ສາມາດປະມວນຜົນໄຟລ໌ CSV ໄດ້', 'error');
          loading.value = false;
        }
      };

      reader.readAsText(file);
      event.target.value = ''; // Reset file input
    };

    return {
      passwords,
      classes,
      searchQuery,
      isEditing,
      formData,
      filteredPasswords,
      filteredClasses,
      showAddModal,
      editPassword,
      savePassword,
      confirmDelete,
      loading,
      columns,
      itemsPerPage,
      currentPage,
      totalPages,
      changePage,
      openEditModal,
      showConfirmation,
      selectedClass,
      selectedYear,
      availableYears,
      passwordModal,
      handleFileUpload
    };

  }
};
</script>
